import { CreditCounterpartyDetailFilterProps } from '@graphql/query/operationLimits/credit/counterpartDetail';

import { DateYearMonthProps } from '~/theme/components/MonthRange';

import useOperationLimitsCompetenceFilters from '../../../hooks/useOperationLimitsCompetenceFilters';

export interface UseOperationLimitsDetailFiltersReturnProps {
  submarket: string;
  submarketOptions: string[];
  monthRangeDefaultValues: DateYearMonthProps;
  monthRangeValues: DateYearMonthProps;
  monthRangeKey: string;
  queryFilters: CreditCounterpartyDetailFilterProps;
  handleSubmarketChange: (value: string | number) => void;
  handleCompetenceRangeChange: (value: DateYearMonthProps) => void;
}

function useOperationLimitsDetailFilters(): UseOperationLimitsDetailFiltersReturnProps {
  const {
    submarket,
    submarketOptions,
    monthRangeDefaultValues,
    monthRangeValues,
    monthRangeKey,
    queryFilters,
    handleSubmarketChange,
    handleCompetenceRangeChange,
  } = useOperationLimitsCompetenceFilters();

  return {
    submarket,
    submarketOptions,
    monthRangeDefaultValues,
    monthRangeValues,
    monthRangeKey,
    queryFilters: {
      startCompetence: queryFilters.startCompetence,
      endCompetence: queryFilters.endCompetence,
    },
    handleSubmarketChange,
    handleCompetenceRangeChange,
  };
}

export default useOperationLimitsDetailFilters;
